import createConverter from './lib/create_converter';
import Err from 'models/err';

export default createConverter(Err);



// WEBPACK FOOTER //
// ./src/scripts/application/dto_converters/err_converter.js